<template>
    <div class="grid">
        <div class="col-12">
            <div class="p-fluid">
                <div class="field grid">
					<label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Start Date</label>
					<div class="col-12 md:col-5">
                        <Calendar :showIcon="true"
                        :showButtonBar="true"
                        v-model="form.start_date"
                        dateFormat="yy-mm-dd" />
					</div>
                    <div class="col-12 mt-2 md:col-1">
                        <label for="name3">End Date</label>
                    </div>
                    <div class="col-12 md:col-4">
                        <Calendar :showIcon="true"
                        :showButtonBar="true"
                        v-model="form.end_date"
                        dateFormat="yy-mm-dd" />
                    </div>
				</div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-2 md:mb-0">Cut Off Day</label>
                    <div class="col-12 md:col-5">
                        <InputText id="total_work_days" type="number" v-model="form.total_work_days"></InputText>
                    </div>
                </div>
                <div class="field grid">
					<label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Placement</label>
					<div class="col-12 md:col-5">
						<Dropdown :class="{'p-invalid' : submitted && !form.placement_id }"
                                v-model="form.placement_id"
                                :options="placements"
                                optionLabel="name"
                                optionValue="id"
                                placeholder="Select Placement" required="true"/>
                        <small class="p-invalid" v-if="submitted && !form.placement_id"
                            >Placement is required.</small
                        >
					</div>
				</div>
                <div class="field grid">
					<label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Division</label>
					<div class="col-12 md:col-5">
						<Dropdown :class="{'p-invalid' : submitted && !form.division_id }"
                                v-model="form.division_id"
                                :options="divisions"
                                optionLabel="name"
                                optionValue="id"
                                placeholder="Select Division" required="true"/>
                        <small class="p-invalid" v-if="submitted && !form.division_id"
                            >Division is required.</small
                        >
					</div>
				</div>
                <div class="field grid">
					<label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Position</label>
					<div class="col-12 md:col-5">
                        <Dropdown
                                :class="{'p-invalid' : submitted && !form.position_id }"
                                v-model="form.position_id"
                                :options="positions"
                                optionLabel="name"
                                optionValue="id"
                                placeholder="Select Position" required="true" />
                        <small class="p-invalid" v-if="submitted && !form.position_id">
                            Position is required.
                        </small>
					</div>
				</div>
                <hr />
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Salary</label>
					<div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.salary"/>
					</div>
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-2 md:mb-0">Allowance</label>
					<div class="col-12 md:col-5">
                        <InputNumber id="allowance" mode="decimal" locale="id-ID" v-model="form.allowance"/>
					</div>
                </div>
                <hr />
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
export default{
    components:{
        Button, Calendar, Dropdown, InputText, InputNumber,
    },
    props: ['model'],
    data(){
        return{
            form: this.$page.props.training ?? {},
            placements: [],
            divisions: [],
            positions: [],
            employees: [],
            submitted: false,
            activeTabs: 0,
        }
    },
    mounted(){
        this.loadData();
    },
    methods:{
        loadData(){
            axios.get(`${this.$page.props.appUrl}api/placement-units`)
            .then((data)=>{
                this.placements = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/divisions`)
            .then((data)=>{
                this.divisions = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Divisions, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/positions`)
            .then((data)=>{
                this.positions = data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Positions, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
            axios.get(`${this.$page.props.appUrl}api/employees`)
            .then((data)=>{
                this.employees = data.data.data;
            })
            .catch((error) => {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Can't Get Data Employees, Refresh Again in 5 second. If still not shown contact support",
                    life: 3000,
                });
            });
        }
    },
}
</script>
